import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { OV_SHOPIFY_STOREFRONT_ACCESS_TOKEN, OV_SHOPIFY_STORE } from '../config/theme';

var storefrontClient = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(query) {
    var variables,
        url,
        request,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            variables = _args.length > 1 && _args[1] !== undefined ? _args[1] : null;
            _context.prev = 1;
            url = "https://".concat(OV_SHOPIFY_STORE, ".myshopify.com/api/2022-04/graphql.json");
            _context.next = 5;
            return fetch(url, {
              body: JSON.stringify({
                query: query,
                variables: variables
              }),
              headers: {
                'X-Shopify-Storefront-Access-Token': OV_SHOPIFY_STOREFRONT_ACCESS_TOKEN,
                'Content-Type': 'application/json'
              },
              method: 'POST'
            });

          case 5:
            request = _context.sent;
            _context.next = 8;
            return request.json();

          case 8:
            return _context.abrupt("return", _context.sent);

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](1);
            console.error(_context.t0);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 11]]);
  }));

  return function storefrontClient(_x) {
    return _ref.apply(this, arguments);
  };
}();

export default storefrontClient;